/* ==========================================================================
   SearcherFli > Client > Config
   ========================================================================== */

/* Import modules */
const { ADULTS, CHILDREN, BABIES, MAJORS } = require('./passengers/constants');

/* Config */
const config = {
    component: 'SearcherFli',
    init: true,
    start: true,
    css: {
        visible: 'is-visible',
        flight: 'is-flight',
        multidestination: 'is-multidestination',
        passengers: 'is-passengers',
        classes: 'is-classes',
        discount: 'is-discount',
        removeButton: 'is-remove-button',
        addButton: 'is-add-button',
        actionButton: 'action-button'
    },
    type: {
        roundtrip: 'searcher-fli-roundtrip',
        oneway: 'searcher-fli-oneway',
        openjaw: 'searcher-fli-openjaw',
        origin: 'searcher-fli-origin',
        destination: 'searcher-fli-destination',
        airlines: 'searcher-fli-airlines',
        calendar: 'searcher-fli-calendar',
        passengers: 'searcher-fli-passengers',
        submit: 'searcher-fli-submit',
        classes: 'searcher-fli-classes',
        discount: 'searcher-fli-discount',
        options: 'searcher-fli-options',
        loading: 'searcher-fli-loading',
        removeButton: 'searcher-fli-remove-button',
        addButton: 'searcher-fli-add-button',
        [ADULTS]: 'searcher-fli-adults',
        [BABIES]: 'searcher-fli-babies',
        [CHILDREN]: 'searcher-fli-children',
        [MAJORS]: 'searcher-fli-majors',
        crossSelling: 'searcher-fli-crossselling',
        acceptButton: 'searcher-fli-accept',
        formState: 'searcher-fli-form-state'
    },
    name: {
        product: 'searcher-fli-product'
    }
};

module.exports = () => config;
